"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCastingFunction = void 0;
var util_1 = require("../segments/util");
function getCastingFunction(traitType) {
    switch (traitType) {
        case 'boolean':
            return function (x) { return !['False', 'false'].includes(x); };
        case 'number':
            return function (x) { return parseFloat(x); };
        case 'semver':
            return function (x) { return (0, util_1.removeSemverSuffix)(x); };
        default:
            return function (x) { return String(x); };
    }
}
exports.getCastingFunction = getCastingFunction;
